import { render, staticRenderFns } from "./ChartCredits.vue?vue&type=template&id=707b8e41&scoped=true&"
import script from "./ChartCredits.vue?vue&type=script&lang=js&"
export * from "./ChartCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b8e41",
  null
  
)

export default component.exports